import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, startWith } from 'rxjs';
import { TopbarTitleComponent } from '@/layout/topbar/components/topbar-title/topbar-title.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { TopbarActionsComponent } from '@/layout/topbar/components/topbar-actions/topbar-actions.component';
import { APP_URLS } from '@/routes/app.paths';
import { AuthStore } from '@/features/auth-store.service';
import type { AppRouteData } from '@/routes/app-route.config';

@Component({
  selector: 'app-topbar',
  imports: [TopbarTitleComponent, TranslocoPipe, TopbarActionsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './topbar.component.scss',
  templateUrl: './topbar.component.html',
})
export class TopbarComponent {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private readonly authStore = inject(AuthStore);

  private navigationEnd = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      startWith(null),
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot.data;
      }),
    ),
  );

  protected topbarConfig = computed(() => (this.navigationEnd() as AppRouteData).topbar);

  protected readonly canCreateOpportunity = computed(() => this.authStore.hasPermission('CREATE_OPPORTUNITY'));

  protected onCreateOpportunity(): void {
    void this.router.navigate([APP_URLS.newOpportunity], { onSameUrlNavigation: 'reload' });
  }
}
